/**
 * Search results LOAD MORE — Section Rendering API. Intercepts the click on the
 * (already-real) `?page=N` link so JS appends the next page's cards in place;
 * without this script the link is a normal full-page pagination fallback
 * (phase-10-search.md non-functional requirement: works with JS disabled).
 *
 * Pattern follows assets/afroyla-material-cards.js's fetch+DOMParser section swap:
 * fetch the same URL with `section_id` appended, parse the returned fragment, move
 * its card nodes into the live grid, then replace the load-more block wholesale so
 * its server-computed "Showing X of Y" text and next-page link (or its absence on
 * the last page) become the new source of truth without re-deriving them in JS.
 */
(function () {
  'use strict';

  function initLoadMore(root) {
    var loadMoreBlock = root.querySelector('[data-afl-load-more]');
    var link = loadMoreBlock && loadMoreBlock.querySelector('[data-afl-load-more-link]');
    if (!loadMoreBlock || !link) return;

    link.addEventListener('click', function (event) {
      event.preventDefault();
      if (link.getAttribute('aria-disabled') === 'true') return;

      var sectionId = root.getAttribute('data-section-id');
      var nextUrl = link.getAttribute('href');
      if (!sectionId || !nextUrl) return;

      var separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

      link.setAttribute('aria-disabled', 'true');
      loadMoreBlock.setAttribute('aria-busy', 'true');

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-afl-search-grid]');
          var grid = root.querySelector('[data-afl-search-grid]');
          if (newGrid && grid) {
            while (newGrid.firstElementChild) {
              grid.appendChild(newGrid.firstElementChild);
            }
          }

          loadMoreBlock.removeAttribute('aria-busy');

          var newLoadMore = doc.querySelector('[data-afl-load-more]');
          if (newLoadMore) {
            loadMoreBlock.replaceWith(newLoadMore);
            initLoadMore(root);
          } else {
            loadMoreBlock.remove();
          }
        })
        .catch(function () {
          loadMoreBlock.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
        });
    });
  }

  document.querySelectorAll('[data-afl-search-results]').forEach(function (root) {
    initLoadMore(root);
  });
})();
